<template>
    <div>
        <b-card no-body class="mb-0">
            <div class="m-2">
                <b-row>
                    <b-col cols="12" md="3"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mobile_tab_max_width_flex mobile_margin_bottom_1rem">
                        <label>Show</label>
                        <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50"
                            @input="filterTable" />
                        <label>entries</label>
                    </b-col>

                    <b-col cols="12" md="9" class="mobile_tab_max_width_flex all_btn_tab">
                        <div class="d-flex align-items-center justify-content-end mobile-view mobile_tab_display_block">
                            <b-button :disabled="!(selected.length > 0)" variant="primary" class=" "
                                v-if="checkPermission($route.name, 'Download')" @click="downloadPdf();">
                                <span class="text-nowrap">Download</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>

            </div>

            <b-table sticky-header ref="refUserListTable" class="position-relative midTableRpt common_big_tbl"
                :items="dataList" responsive :fields="computedColumns" primary-key="id" :sort-by.sync="sortBy"
                show-empty empty-text="No matching records found" :sort-desc.sync="isSortDirDesc"
                :class="'remove_overflow'">

                <template #cell(info)="items">
                    <feather-icon :icon="items.detailsShowing ? 'EyeIcon' : 'EyeOffIcon'"
                        @click="items.toggleDetails" />
                </template>
                <template #head(checkbox)="items">
                    <b-form-checkbox class="custom-control-warning p-0" v-model="selectAll" @change="selectall" />
                </template>

                <template #cell(checkbox)="items">
                    <b-form-checkbox v-model="selected" :value="items.item" class="custom-control-warning my-1" />
                </template>

                <template #cell(supplier)="items">
                    <span class="text-capitalize">
                        {{ items.item.supplier_name }}
                    </span>
                </template>

                <template #cell(deli_site)="items">
                    <span class="text-capitalize">
                        {{ items.item.delivery_site }}
                    </span>
                </template>

                <template #cell(sites)="items">
                    <span class="text-capitalize">
                        {{ items.item.sites_names }}
                    </span>
                </template>

                <template #cell(moq)="items">
                    <span class="text-capitalize" @click="items.toggleDetails" v-if="items.item.moq">
                        ${{ items.item.moq | currency }}
                    </span>
                    <span class="text-capitalize" @click="items.toggleDetails" v-else>
                        N/A
                    </span>
                </template>

                <template #cell(delivery_fee)="items">
                    <span class="text-capitalize" @click="items.toggleDetails">
                        ${{ items.item.delivery_fee | currency }}
                    </span>
                </template>

                <template #cell(ordered_amount)="items">
                    <!-- <span class="text-capitalize">${{ items.item.total_from_area }}</span> -->
                    <b-badge pill :variant="variantColor(items.item.moq_fulfiled)" class="text-capitalize">
                        ${{ items.item.total_from_area | currency }}
                    </b-badge>
                </template>

                <template #cell(actions)="items">
                    <b-link v-b-tooltip.hover.v-warning title="View" variant="outline-warning"
                        @click="downloadPdf(items.item);">
                        <feather-icon icon="FileIcon" class="mr-1 mediumSize" />
                    </b-link>
                    <b-link v-b-tooltip.hover.v-warning title="Update" variant="outline-warning"
                        @click="moq_deliSite_updateModal(items.item.pdf, items.item.sites_names, items.item.delivery_site, items.item.supplier_name)">
                        <feather-icon icon="EditIcon" class="mediumSize" />
                    </b-link>
                </template>

                <template #row-details="items">
                    <div class="p-1 px-2 fbDetail mb-1">
                        <b-row>
                            <b-col cols="12" xl="12">
                                <table class="mt-2 mt-xl-0 w-100">
                                    <tr class="mb-1">
                                        <th class="pb-50" style="width: 10%">
                                            <div class="d-flex align-items-center">

                                                <div class="ml-1">
                                                    <h6 class="mb-0 mediumFonts">
                                                        Fee Waivable
                                                    </h6>
                                                </div>
                                            </div>
                                        </th>
                                        <td class="pb-50 mediumFonts" style="width: 15%;padding-top: 8px;">
                                            <span class="text-capitalize"
                                                v-if="items.item.fee_weiver == true">Yes</span>
                                            <span class="text-capitalize" v-else>No</span>
                                        </td>
                                        <th class="pb-50" style="width: 10%">
                                            <div class="d-flex align-items-center">

                                                <div class="ml-1">
                                                    <h6 class="mb-0 mediumFonts">
                                                        MOQ Fulfiled?
                                                    </h6>
                                                </div>
                                            </div>
                                        </th>
                                        <td class="pb-50 mediumFonts" style="width: 15%;padding-top: 8px;">
                                            <span class="text-capitalize"
                                                v-if="items.item.moq_fulfiled == true">Yes</span>
                                            <span class="text-capitalize" v-else>No</span>
                                        </td>
                                        <th class="pb-50" style="width: 10%">
                                            <div class="d-flex align-items-center">
                                                <div class="ml-1">
                                                    <h6 class="mb-0 mediumFonts">
                                                        Month
                                                    </h6>
                                                </div>
                                            </div>
                                        </th>
                                        <td class="pb-50 mediumFonts" style="width: 15%;padding-top: 8px;">
                                            <span class="text-capitalize">{{ selectedMonth }}</span>
                                        </td>
                                    </tr>

                                    <tr class="mb-1">
                                        <th class="pb-50" style="width: 10%">
                                            <div class="d-flex align-items-center">
                                                <div class="ml-1">
                                                    <h6 class="mb-0 mediumFonts">
                                                        Order Type
                                                    </h6>
                                                </div>
                                            </div>
                                        </th>
                                        <td class="pb-50 mediumFonts" style="width: 15%;padding-top: 8px;">
                                            <span class="text-capitalize">{{ items.item.order_type }}</span>
                                        </td>
                                        <th class="pb-50" style="width: 10%">
                                            <div class="d-flex align-items-center">

                                                <div class="ml-1">
                                                    <h6 class="mb-0 mediumFonts">
                                                        Ordered Items Qty
                                                    </h6>
                                                </div>
                                            </div>
                                        </th>
                                        <td class="pb-50 mediumFonts" style="padding-top: 8px;width: 15%;">
                                            {{ items.item.ordered_items_qty }}
                                        </td>
                                        <th class="pb-50" style="width: 10%">
                                            <div class="d-flex align-items-center">

                                                <div class="ml-1">
                                                    <h6 class="mb-0 mediumFonts">
                                                        Area In-Charge
                                                    </h6>
                                                </div>
                                            </div>
                                        </th>
                                        <td class="pb-50 mediumFonts" style="width: 25%;padding-top: 8px;">
                                            {{ items.item.sites_in_charge }}
                                        </td>
                                    </tr>
                                    <tr class="mb-1">
                                        <th class="pb-50" style="width: 16%">
                                            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                                variant="outline-secondary" @click="items.toggleDetails" size="sm"
                                                class="ml-1">
                                                Hide Detail
                                            </b-button>
                                        </th>
                                        <td class="pb-50 mediumFonts" style="width: 17%;padding-top: 8px;">

                                        </td>
                                        <th class="pb-50" style="width: 16%">
                                        </th>
                                        <td class="pb-50 mediumFonts" style="width: 17%;padding-top: 8px;">

                                        </td>
                                        <th class="pb-50" style="width: 16%">
                                        </th>
                                        <td class="pb-50 mediumFonts" style="width: 17%;padding-top: 8px;">
                                        </td>
                                    </tr>
                                </table>
                            </b-col>
                        </b-row>
                    </div>
                </template>
            </b-table>

            <!-- Pagination -->
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col cols="12" sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start">
                        <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }}</span>
                    </b-col>
                    <b-col cols="12" sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end">
                        <b-pagination v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" first-number
                            last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item"
                            @input="filterTable">
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
        <b-modal id="updateDeliSite" ref="updateDeliSite" cancel-variant="outline-secondary" size="lg"
            ok-variant="outline-warning" ok-title="Submit" cancel-title="Close" title="Update Delivery Site"
            no-close-on-backdrop @ok="updateDeliSite()" :ok-disabled="updated_deli_site_tmp == null">
            <b-form-group label="Supplier Name" class="mb-4">
                <v-select v-model="deliSite_edit_item.supplier_name" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="supplier_name" disabled placeholder="Select" :clearable="false" />
            </b-form-group>
            <b-form-group label="Site" class="mb-4">
                <v-select v-model="deliSite_edit_item.current_site" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="site_name" disabled placeholder="Select" :clearable="false" />
            </b-form-group>
            <b-form-group label="Currently Delivery Site" class="mb-4">
                <v-select v-model="deliSite_edit_item.delivery_site" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="site_name" disabled placeholder="Select" :clearable="false" />
            </b-form-group>
            <b-form-group label="Select New Delivery Site" class="mb-4">
                <v-select v-model="updated_deli_site_tmp" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="sites" label="site_name" placeholder="Select" :clearable="false" />
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormGroup, BFormRadio,
    BBadge, BDropdown, BDropdownItem, BPagination, BBreadcrumb, BCardBody, BAlert, VBTooltip, BFormCheckbox, BForm, BFormSelect, BFormSelectOption
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { GET_API, POST_API } from "../../../store/actions.type"
import Ripple from 'vue-ripple-directive';
import moment from "moment";
import Bus from "../../../event-bus";
import axios from 'axios';

export default {
    props: ["selectedArea", "selectedSupplier", "selectedMonth", "selectedYear" , "deliverySites", "selectedDeliverySite"],
    components: {
        BAlert,
        BCard,
        BRow,
        BCol,
        BFormInput,
        BButton,
        BTable,
        BMedia,
        BAvatar,
        BLink,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,
        BCardBody,
        vSelect,
        BBreadcrumb,
        BFormGroup,
        BFormCheckbox,
        BForm,
        BFormSelect,
        BFormSelectOption,
        BFormRadio
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip
    },
    watch: {
        selectedArea: function (newVal, oldVal) { // watch it
            setTimeout(() => {
                this.filterTable();
            }, 1000)
        },
        selectedSupplier: function (newVal, oldVal) { // watch it
            this.filterTable();
        },
        selectedMonth: function (newVal, oldVal) {
            setTimeout(() => {
                this.filterTable();
            }, 1000)
        },
        selectedYear: function(newVal, oldVal) {
            setTimeout(() => {
                this.filterTable();
            }, 1000)
        },
        selectedDeliverySite: function () {
            this.filterTable();
        },
        updated_deli_site_tmp: function () {
            this.deliSiteChange();
        }
    },
    computed: {
        computedColumns() {
            if (!this.checkPermission(this.$route.name, 'Download')) {
                return this.tableColumns.filter(column => !column.require_permission);
            }
            else {
                return this.tableColumns;
            }
        }
    },
    data() {
        return {

            tableColumns: [
                { key: 'checkbox', label: '', sortable: false, thStyle: { width: '1%' } },
                { key: 'info', label: 'INFO', sortable: false, thStyle: { width: '1%' } },
                { key: 'supplier', label: 'Supplier Name', sortable: false, thStyle: { width: '20%' } },
                { key: 'deli_site', label: 'Deliver To', sortable: false, thStyle: { width: '20%' } },
                { key: 'sites', label: 'Project Sites', sortable: false, thStyle: { width: '20%' } },
                { key: 'moq', label: 'MOQ', sortable: false, thStyle: { width: '10%' } },
                { key: 'delivery_fee', label: 'Delivery Fee', sortable: false, thStyle: { width: '10%' } },
                { key: 'ordered_amount', label: 'Total Amount Ordered', sortable: false, thStyle: { width: '10%' } },
                { key: 'actions', label: 'Action', sortable: false, thStyle: { width: '10%' }, require_permission: true },
            ],

            sites: [],
            suppliers: [],
            from: 0,
            to: 0,
            items: [],
            isSortDirDesc: false,
            sortBy: 'id',
            perPageOptions: [10, 20, 50, 100],
            perPage: 10,
            totalRecords: 0,
            currentPage: 1,

            error_message: '',
            popshowDismissibleAlert: false,
            selectAll: false,
            selected: [],
            currentItem: null,
            pdf_type: 'pdf',

            deliSite_edit_item: {
                order_id: [],
                current_site: '',
                delivery_site: '',
                supplier_name: '',
            },
            updated_deli_site: null,
            updated_deli_site_tmp: null,
            site_user: null,
        }
    },
    methods: {
        showAlert() {
            Swal.fire({
                position: 'center',
                icon: 'error',
                text: this.error_message,
                showConfirmButton: false,
                timer: 3000
            })
        },
        downloadPdf(selected_record) {
            var records_to_show = this.selected;
            if (selected_record != undefined) {
                records_to_show = [selected_record]
            }
            return this.$store.dispatch(POST_API, {
                data: {
                    moq_reports: records_to_show,
                    area: this.selectedArea,
                    month: this.selectedMonth,
                },
                api: '/api/inventory-moq-pdf-download'
            }).then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showAlert();
                } else {
                    var path = this.$store.getters.getResults.data;
                    window.open(path, '_blank')
                }
            })
        },

        dataList() {
            return this.$store.dispatch(POST_API, {
                data: {
                    page: this.currentPage,
                    keyword: this.searchQuery,
                    rowsPerPage: this.perPage,
                    role: this.$store.getters.currentUser.role,
                    area: this.selectedArea,
                    supplier: this.selectedSupplier,
                    month: this.selectedMonth,
                    year: this.selectedYear,
                    sites: this.deliverySites,
                    year: this.selectedYear,
                    selected_delivery_site: this.selectedDeliverySite,
                },
                api: '/api/inventory-moq-list'
            })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                        this.items = this.$store.getters.getResults.data.docs;
                        this.totalRecords = this.$store.getters.getResults.data.total;
                        this.perPage = this.$store.getters.getResults.data.limit;
                        this.from = this.$store.getters.getResults.data.from;
                        this.to = this.$store.getters.getResults.data.to;
                        return this.items;
                    }
                });
        },

        filterTable() {
            this.$refs.refUserListTable.refresh();
            this.selected = [];
            this.selectAll = false;
        },
        selectall(e) {
            this.selected = [];
            if (e) {
                // console.log(this.items)
                this.selected = this.items;
            }
        },
        variantColor(status) {
            if (status == false) {
                return 'danger';
            } else {
                return 'success';
            }
        },
        moq_deliSite_updateModal(order_id, current_site, delivery_site, supplier_name) {
            this.deliSite_edit_item = {
                order_id: order_id,
                current_site: current_site,
                delivery_site: delivery_site,
                supplier_name: supplier_name
            };
            this.$refs['updateDeliSite'].show();
        },
        allSites() {
            return this.$store.dispatch(POST_API, {
                data: {
                    role: this.$store.getters.currentUser.role,
                },
                api: '/api/all-inventory-sites'
            })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                        window.scrollTo(0, 0);
                    } else {
                        var data = this.$store.getters.getResults.data;

                        this.sites = data;
                    }
                });
        },
        updateDeliSite() {
            if(this.updated_deli_site_tmp.site_name == this.deliSite_edit_item.delivery_site){
                this.error_message = "Please select a different delivery site";
                this.updated_deli_site_tmp = null;
                this.showAlert();
                return;
            }
            return this.$store.dispatch(POST_API, {
                data: {
                    item: this.deliSite_edit_item,
                    updated_deli_site: this.updated_deli_site,
                    site_user: this.site_user,
                },
                api: '/api/inventory-moq-update-deliSite'
            })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                        // show success
                        this.successAlert().then(() => {
                            this.filterTable();
                        });
                    }
                    this.updated_deli_site_tmp = null;
                });
        },
        deliSiteChange() {

            return this.$store.dispatch(POST_API, {
                data: {
                    site: this.updated_deli_site_tmp._id,
                },
                api: '/api/site-area-user-info'
            })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                        window.scrollTo(0, 0);
                    } else {
                        var data = this.$store.getters.getResults.data;
                        if (data.length > 0) {
                            this.updated_deli_site = data[0];
                        }
                        if (data.length > 0 && data[0].user) {
                            this.site_user = data[0].user;
                        } else {
                            this.site_user = null;
                        }
                    }
                });
        },

    },
    mounted() {
        this.allSites();
    }

}
</script>

<style lang="scss" scoped>
.per-page-selector {
    width: 90px;
}

.border-danger {
    border: 2px solid #ea5455 !important;
    padding: 2px !important;
}

.border-secondary {
    border: 2px solid rgb(221, 221, 221) !important;
    padding: 2px !important;
}

.card-body {
    padding-top: 1rem !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>